import i18n from '../../i18n/index.ts';
import type { FileState } from '../../lib/types.ts';

/** «03.07» — короткая дата, как в прототипе. */
export function shortDate(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString(i18n.language, { day: '2-digit', month: '2-digit' });
}

/** «34 МБ», «7,4 ГБ». Объём всегда приходит с бэкенда; null = размер неизвестен. */
export function formatBytes(bytes: number | null): string | null {
  if (bytes == null) return null;
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  const digits = value < 10 && unit > 0 ? 1 : 0;
  const num = value.toLocaleString(i18n.language, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
  return `${num} ${i18n.t(`archive.unit.${units[unit]}`)}`;
}

/**
 * Файл был и его освободили. ЕДИНСТВЕННОЕ состояние, которое отнимает
 * способность и красит чип в красный/янтарный. 'absent' — файла ещё нет
 * (не отрендерен / качается), это не потеря.
 */
export const isFreed = (file: FileState | null | undefined): boolean => file?.status === 'freed';

/** Файл в хранилище — способность, которую он даёт, доступна. */
export const isAvailable = (file: FileState | null | undefined): boolean =>
  file?.status === 'available';
